import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addWarehouseApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addWarehouse = createAsyncThunk('addWarehouse', async (payload) => {
  return await addWarehouseApi(payload);
});

const addWarehouseSlice = createSlice({
  name: 'addWarehouse', // Unique Name
  initialState,
  reducers: {
    addWarehouseReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addWarehouse.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addWarehouse.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addWarehouse.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addWarehouseReset } = addWarehouseSlice.actions;

export default addWarehouseSlice.reducer;
